"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentV1 = exports.experimentsWithRedirection = exports.remove = exports.duplicateV1 = exports.listV1 = exports.getHistory = exports.patchV1 = exports.postV1 = exports.getV1 = exports.pause = exports.play = exports.experimentApi = exports.listExperimentsPerformance = exports.getSummary = exports.reset = exports.attachAudience = exports.update = exports.listCustomizationsExposure = exports.listExperimentsExposure = exports.listExperiments = exports.listCustomizations = exports.nested = void 0;
const createApi_1 = require("../../helpers/createApi");
const types_1 = require("../../types");
const types_2 = require("./types");
const nested = (caller) => (options) => caller(`/api/interface/accounts/${options.accountId}/tests/${options.testId}/nested`).get();
exports.nested = nested;
const customizationsQuery = {
    _max_per_page: 0,
    'filter[_order][id]': 'DESC',
    'filter[exclude_tag][]': ['archive', 'deleted'],
    'filter[parent][]': 0,
    'filter[type][]': ['mastersegment', 'segmentation'],
};
const listCustomizations = (caller) => (options) => caller(`/api/core/accounts/${options.accountId}/tests`).get(customizationsQuery);
exports.listCustomizations = listCustomizations;
const experimentsQuery = {
    _max_per_page: 0,
    'filter[parent][]': 0,
    'filter[type][]': ['ab', 'predictive', 'multivariate', 'multipage'],
    'filter[exclude_tag][]': ['archive', 'deleted'],
    'filter[_order][id]': 'DESC',
};
const listExperiments = (caller) => (options) => caller(`/api/core/accounts/${options.accountId}/tests`).get(experimentsQuery);
exports.listExperiments = listExperiments;
const buildExposureParams = (initialParams, { testId, searchText, pagination, includedIds }) => {
    const finalParams = {
        ...initialParams,
        _max_per_page: pagination,
        'filter[exposure][test_id]': testId,
        'filter[search]': searchText,
        'filter[parent][]': 0,
        'filter[exclude_tag][]': ['archive', 'delete'],
        'filter[_order][id]': 'DESC',
    };
    if (includedIds) {
        finalParams['filter[exposure][included_id][]'] = includedIds;
    }
    return finalParams;
};
const listExperimentsExposure = (caller) => (options) => {
    let experimentsExposureQuery = {
        'filter[type][]': ['ab', 'predictive', 'multivariate', 'multipage'],
    };
    experimentsExposureQuery = buildExposureParams(experimentsExposureQuery, options);
    return caller(`/api/core/accounts/${options.accountId}/tests`).get(experimentsExposureQuery);
};
exports.listExperimentsExposure = listExperimentsExposure;
const listCustomizationsExposure = (caller) => (options) => {
    let customizationsExposureQuery = {
        'filter[type][]': ['mastersegment', 'segmentation'],
    };
    customizationsExposureQuery = buildExposureParams(customizationsExposureQuery, options);
    return caller(`/api/core/accounts/${options.accountId}/tests`).get(customizationsExposureQuery);
};
exports.listCustomizationsExposure = listCustomizationsExposure;
const update = (caller) => (options) => caller(`/api/core/accounts/${options.accountId}/tests/${options.testId}`).put(options.payload);
exports.update = update;
const attachAudience = (caller) => (options) => caller(`/api/core/accounts/${options.accountId}/tests/${options.testId}/audiences`).post(options.payload);
exports.attachAudience = attachAudience;
const reset = (caller) => ({ accountId, testId }) => caller(`/api/core/accounts/${accountId}/tests/${testId}/reset`).patch();
exports.reset = reset;
const getSummary = (caller) => ({ accountId, testId }) => caller(`/backend/accounts/${accountId}/tests/${testId}/summary`).get();
exports.getSummary = getSummary;
const listExperimentsPerformance = (caller) => ({ accountId, type, state, status, ...filters }) => caller(`/backend/accounts/${accountId}/tests`).get({
    ...(type ? { type: type.join(',') } : {}),
    ...(state ? { state: state.join(',') } : {}),
    ...(status ? { status: status.join(',') } : {}),
    ...filters,
});
exports.listExperimentsPerformance = listExperimentsPerformance;
exports.experimentApi = (0, createApi_1.createAPIFactory)({
    listCustomizations: exports.listCustomizations,
    listExperiments: exports.listExperiments,
    listExperimentsExposure: exports.listExperimentsExposure,
    listCustomizationsExposure: exports.listCustomizationsExposure,
    listExperimentsPerformance: exports.listExperimentsPerformance,
    update: exports.update,
    attachAudience: exports.attachAudience,
    reset: exports.reset,
    nested: exports.nested,
    getSummary: exports.getSummary,
});
const play = (caller) => ({ accountId, testId, forcePlay = false }) => caller(`/accounts/${accountId}/tests/${testId}`).patch({ active: true, force_play: forcePlay });
exports.play = play;
const pause = (caller) => ({ accountId, testId }) => caller(`/accounts/${accountId}/tests/${testId}`).patch({ active: false });
exports.pause = pause;
const getV1 = (caller) => ({ accountId, testId }) => {
    return caller(`/accounts/${accountId}/tests/${testId}`).get();
};
exports.getV1 = getV1;
const postV1 = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/tests`).post(payload, { withResponse: true });
};
exports.postV1 = postV1;
const patchV1 = (caller) => ({ accountId, testId, payload }) => {
    return caller(`/accounts/${accountId}/tests/${testId}`).patch(payload);
};
exports.patchV1 = patchV1;
const getHistory = (caller) => ({ accountId, testId, payload: { _max_per_page = 100, order = {
    sortBy: types_2.HistoryOrderType.ID,
    sortDir: types_2.HistoryOrderBy.DESC,
}, }, }) => {
    const { sortBy, sortDir } = order;
    return caller(`/accounts/${accountId}/tests/${testId}/history`).get({
        _max_per_page,
        [`_order[${sortBy}]`]: sortDir,
    });
};
exports.getHistory = getHistory;
const listV1 = (caller) => ({ accountId, filters = {}, _page, _order = {}, _max_per_page }) => {
    const url = `/accounts/${accountId}/tests`;
    const { state, status, ...otherFilters } = filters;
    const filterState = state && state.map(({ value, strict }) => `${strict ? '~' : ''}${value}`);
    const filterStatus = status && status.map(({ value, strict }) => `${strict ? '~' : ''}${value}`);
    _order[types_2.ExperimentSortBy.ID] = _order[types_2.ExperimentSortBy.ID] || types_1.OrderBy.DESC;
    return caller(url).get({
        _page,
        ...otherFilters,
        state: filterState,
        status: filterStatus,
        _max_per_page,
        _order,
    });
};
exports.listV1 = listV1;
const duplicateV1 = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/tests`).post(payload, { withResponse: true });
};
exports.duplicateV1 = duplicateV1;
const remove = (caller) => ({ accountId, testId }) => caller(`/accounts/${accountId}/tests/${testId}`).delete();
exports.remove = remove;
const experimentsWithRedirection = (caller) => ({ accountId, has_redirection = true }) => caller(`/accounts/${accountId}/tests`).get({ has_redirection });
exports.experimentsWithRedirection = experimentsWithRedirection;
exports.experimentV1 = (0, createApi_1.createAPIFactory)({
    list: exports.listV1,
    get: exports.getV1,
    post: exports.postV1,
    patch: exports.patchV1,
    remove: exports.remove,
    getHistory: exports.getHistory,
    duplicate: exports.duplicateV1,
    play: exports.play,
    pause: exports.pause,
    experimentsWithRedirection: exports.experimentsWithRedirection,
});
//# sourceMappingURL=api.js.map